export default __webpack_public_path__ + "static/media/12.ff264d7c.jpg";